<div class="d-flex group-setting-container" *ngIf="influencerGroup">
  <form #newGroupSettingForm="ngForm" class="setting-form">
    <div class="row setting-header">
      <div class="col-md-9 col-sm-9 text-semi-bold-font">
        <div class="group-setting-title">{{'group_details.setting' | translate}}</div>
      </div>
      <div class="col-md-3 col-sm-3 d-flex justify-content-end">
        <button class="btn setting-btn edit-group-name-btn" (click)="updateGroup()">{{'new_group_settings.edit_group_name_btn' | translate}}</button>
        <button class="btn btn-default setting-btn" (click)="onSubmit()">{{'group_details.btn' | translate}}</button>
      </div>
    </div>
    <div class="seperate-line"></div>
    <div class="row setting-content">
      <div class="col-md-6 col-sm-6">
        <div class="row setting-line">
          <div class="col-md-11 col-sm-11">
                <span class="control-label">
                  {{'group_details.indetify_relevant_influencer' | translate}}
                </span>
          </div>
          <div class="col-md-1 col-sm-1 d-flex justify-content-end toggle-button-wrapper">
            <achoo-toggle-switch [(model)]="identifyRelevantInfluencer" (switchChange)="toggleIdentifyRelevantInfluencers($event)"></achoo-toggle-switch>
          </div>
        </div>
      </div>
    </div>
    <div class="seperate-line"></div>
    <auto-group-sources *ngIf="groupSourceDataIsReady() && identifyRelevantInfluencer"
                        [influencerGroupId]="influencerGroup.id"
                        [autoGroupSource]="influencerGroup.sources"
                        [autoGroupSourceList]="autoGroupSourceList"
                        [listProject]="listProject"
                        [campaignList]="campaignList"
                        [influencerGroupList]="influencerGroupList"
                        [brandedSignUpConfig]="brandedSignUpConfig"
                        (editOrCreateProjectEvent)="editOrCreateProject($event)"
                        [(showSourceRequiredErrorMessage)]="showSourceRequiredErrorMessage"
                        #autoGroupSource>
    </auto-group-sources>
    <auto-group-filters *ngIf="supportedFilterTypeOptions && supportedFilterTypeOptions.length > 0 && identifyRelevantInfluencer"
                        [supportedFilterOptions]="supportedFilterTypeOptions"
                        [autoGroupFilters]="influencerGroup.filters"
                        #autoGroupFilter>
    </auto-group-filters>
  </form>
</div>



// WEBPACK FOOTER //
// ./src/app/main/group-details/new-group-settings/new-group-settings.component.html